import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineBodyProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    withTimelineContext
} from "../../context";
import Text from "../../../text";

const TimelineBodyContent: FC<TimelinePartContentProps<ITimelineBodyProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        shapeConfigs,
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlPaddings,
        shapeConfigs,
        radiuses,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {
            typeof children === "string" ?
                <Text
                    customTheme={customTheme}
                    variant="bodyMediumSize"
                    color="high"
                >
                    {children}
                </Text>
            :
                children
        }
    </View>;
};
export default withTimelineContext("Body", TimelineBodyContent);
